<div class="td-wb-toggle-with-label"
     role="radiogroup"
     [attr.aria-label]="ariaLabel()"
     [attr.aria-labelledby]="ariaLabelledBy()"
     [class.td-wb-toggle-label--outlined]="outline()"
     [class.td-wb-toggle-label--white]="whiteBackground()"
     [class.td-wb-toggle-label--disabled]="disabled()"
     [class.td-wb-toggle-label--readonly]="readonly()">
  <ng-content />
  <span class="td-wb-toggle"></span>
</div>
